import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import SelectAndInputFieldsForNestedAttribute from 'components/assignedPersonsAtRisk/selectAndInputFieldsForNestedAttribute/components/SelectAndInputFieldsForNestedAttribute';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <AppWrapper {...contextProps}>
      <SelectAndInputFieldsForNestedAttribute {...wrappedProps} />
    </AppWrapper>
  );
}
